import { i18n } from "../../../../language";
import store from "../../../../store";

let isDarkMode = () => store.state.user.darkMode;

export default function getData(data, title) {
    return {
        grid: {
            right: "20%",
        },
        /*title: {
            text: title || i18n.tc('message.distConversation')
        },*/
        legend: {
            show: true,
            orient: "vertical",
            left: 0,
            textStyle: {
                color: isDarkMode() ? "white" : "black",
            },
        },
        toolbox: {
            feature: {
                saveAsImage: {
                    pixelRatio: 2,
                    title: i18n.t("message.download"),
                },
            },
        },
        series: [
            {
                type: "pie",
                radius: "50%",
                data,
                emphasis: {
                    itemStyle: {
                        shadowBlur: 10,
                        shadowOffsetX: 0,
                        shadowColor: "rgba(0, 0, 0, 0.5)",
                    },
                },
            },
        ],
    };
}
